import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, CircularProgress, Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { apiGetPayoutList, apiGetPayoutLogs } from "../../../utils/api/api";
import { formatDateTime, toLocalePriceNoDecimal } from "../../../utils/StringUtil";

const PayoutLog = ({ scheme, open }) => {

    const [payouts, setPayouts] = useState([]);
    const [expanded, setExpanded] = useState(null);
    const [payoutLogs, setPayoutLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isPayoutLogLoading, setIsPayoutLogLoading] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : null);
    };

    const getPayouts = (param = {}) => {
        param.oppRid = scheme.oppRid;
        setIsLoading(true);
        apiGetPayoutList(param)
            .then((data) => {
                setIsLoading(false);
                setPayouts(data);
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error);
            });
    }

    const getPayoutLogs = (param = {}) => {
        param.pytRid = expanded;
        setIsPayoutLogLoading(true);
        apiGetPayoutLogs(param)
            .then((data) => {
                setIsPayoutLogLoading(false);
                setPayoutLogs(data);
            })
            .catch((error) => {
                setIsPayoutLogLoading(false);
                console.log(error);
            });
    }


    useEffect(() => {
        if (open) {
            setIsLoading(true);
            getPayouts();
        }
    }, [open]);

    useEffect(() => {
        if (expanded !== null) {
            getPayoutLogs();
        }
    }, [expanded]);

    return (
        <div className="px-2">
            <table className="table table-borderless w-100 mb-0">
                <thead>
                    <tr className="fs-med-semibold text-center ">
                        <th className="text-start " style={{ width: "14%" }}>Payout Type</th>
                        <th className="text-center" style={{ width: "14%" }}>Payout Date</th>
                        <th className="text-end" style={{ width: "16%" }}>Total Gross Amount</th>
                        <th className="text-end" style={{ width: "25%" }}>Total Fee</th>
                        <th className="text-end" style={{ width: "14%" }}>Total TDS</th>
                        <th className="text-end" style={{ width: "17%" }}>Total Net Amount</th>
                    </tr>
                </thead>
            </table>

            {payouts.length > 0 ? (
                payouts.map((data) => {
                    return (
                        <div>
                            {isLoading ? <CircularProgress /> :
                                (
                                    <>

                                        <Accordion
                                            key={data.pytRid}
                                            expanded={expanded === data.pytRid}
                                            onChange={handleChange(data.pytRid)}
                                            style={{
                                                border: "0.5px solid  #e0e0e0",
                                                borderRadius: "8px",
                                                boxShadow: "none",
                                                marginBottom: "2px",
                                            }}
                                        >

                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon color='primary' />}
                                                aria-controls={`panel-${data.pytRid}-content`}
                                                id={`panel-${data.pytRid}-header`}
                                                style={{ backgroundColor: "#F3EEF7" }}
                                            >

                                                <table className="w-100">
                                                    <tbody>
                                                        <tr className="fs-med-semibold text-center">
                                                            <td className="text-start" style={{ width: "14%" }}>{data.payoutType}</td>
                                                            <td className="text-center" style={{ width: "14%" }}>
                                                                {data.payoutDate ? formatDateTime(data.payoutDate) : 'N/A'}
                                                            </td>
                                                            <td className="text-end" style={{ width: "16%" }}>{toLocalePriceNoDecimal(data.totalGrossAmount)}</td>
                                                            <td className="text-end" style={{ width: "26%" }}>{toLocalePriceNoDecimal(data.totalFee)}</td>
                                                            <td className="text-end" style={{ width: "15%" }}>{toLocalePriceNoDecimal(data.totalTds)}</td>
                                                            <td className="text-end" style={{ width: "17%" }}>{toLocalePriceNoDecimal(data.totalNetAmount)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </AccordionSummary>
                                            <Divider />
                                            <AccordionDetails>
                                                {isPayoutLogLoading ? <CircularProgress /> : (
                                                    <>
                                                        {expanded === data.pytRid && payoutLogs?.length > 0 ? (
                                                            <>
                                                                <table className="table table-striped table-borderless w-100 ">
                                                                    <thead>
                                                                        <tr className="fs-normal-semibold text-center">
                                                                            <th scope="col" style={{ width: "14%" }}>
                                                                                <p className="mb-2">Investor Name</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "14%" }}><p className="mb-2 text-center p-0">Investor Code</p></th>
                                                                            <th scope="col" style={{ width: "15%" }}>
                                                                                <p className="mb-2 text-end" >Gross Amount</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "12%" }}>
                                                                                <p className="mb-2 text-center" >Fee Type</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "9%" }}>
                                                                                <p className="mb-2 text-end" >Fee</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "15%" }}>
                                                                                <p className="mb-2 text-end">TDS</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "18%" }}>
                                                                                <p className="mb-2 text-end" >Net Amount</p>
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {payoutLogs.map((data, key) => {
                                                                            if (data.commitment === 0) {
                                                                                return null;
                                                                            }
                                                                            return (
                                                                                <tr className="fs-normal-medium text-center" key={key}>

                                                                                    <td className="pt-3" style={{ width: "14%" }}>
                                                                                        <span style={{ whiteSpace: "nowrap" }}>
                                                                                            {data?.invName ?? ''}
                                                                                            {/* {data?.invCode && ` (${data.invCode})`} */}
                                                                                        </span>
                                                                                        <div className="fs-small-regular text-muted" style={{ display: "block" }}>{data?.className}</div>

                                                                                    </td>
                                                                                    <td className="pt-3 text-center" style={{ width: "14%" }} >{data?.invCode}</td>
                                                                                    <td className="pt-3 text-end" style={{ width: "15%" }}>{toLocalePriceNoDecimal(data.grossAmount)}</td>
                                                                                    <td className="pt-3 text-center" style={{ width: "17%" }}><p className="text-justify">{data?.feeType ? data.feeType : "---"}</p></td>
                                                                                    <td className="pt-3 text-end" style={{ width: "9%" }}>{data?.fee ? toLocalePriceNoDecimal(data.fee) : "---"}</td>
                                                                                    <td className="pt-3 text-end" style={{ width: "15%" }}>{data?.tds ? toLocalePriceNoDecimal(data.tds) : "---"}</td>
                                                                                    <td className="pt-3 text-end" style={{ width: "18%" }}>{toLocalePriceNoDecimal(data?.netAmount) ?? '---'} </td>
                                                                                </tr>
                                                                            );
                                                                        })}

                                                                    </tbody>
                                                                </table>
                                                            </>
                                                        ) : (
                                                            <div className="text-center p-4">No logs found.</div>)}
                                                    </>
                                                )}
                                            </AccordionDetails>
                                        </Accordion></>
                                )
                            }

                        </div>
                    )
                })
            ) : (
                <div className="text-center p-4">No Payouts found.</div>
            )}
        </div>
    )
}

export default PayoutLog;